import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Drawer } from 'components/shared/Drawer';
import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { SwitchField } from 'components/FormikFields';

import {
  validationSchema,
  getInitialValues,
} from './CourseSettings.formConfig';

import styles from './CourseSettings.module.scss';

const CourseSettings = ({
  open,
  saveLoading,
  course,
  onClose,
  onSaveClick,
}: {
  open: any;
  saveLoading: any;
  course: any;
  onClose: any;
  onSaveClick: any;
}) => (
  <Drawer open={open} headerContent="Course settings" onClose={onClose}>
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={getInitialValues(course)}
      validationSchema={validationSchema}
      onSubmit={onSaveClick}
    >
      <Form className={styles.form}>
        <div className={styles.inner}>
          <FormikField
            name="withCertificate"
            component={SwitchField}
            controlProps={{
              label: 'Course certificate',
            }}
            componentProps={{
              type: 'checkbox',
            }}
          />
          <FormikField
            name="trial"
            component={SwitchField}
            controlProps={{
              label: 'Trial course',
            }}
            componentProps={{
              type: 'checkbox',
            }}
          />
        </div>

        <div className={styles.actions}>
          <Button
            className={styles.action}
            size="md"
            variant="outlined"
            onClick={onClose}
          >
            {getTranslation('common.button.cancel')}
          </Button>
          <Button
            className={styles.action}
            startIcon={
              saveLoading && <Loading color={'var(--color-white-primary)'} />
            }
            type="submit"
            size="md"
          >
            Save
          </Button>
        </div>
      </Form>
    </Formik>
  </Drawer>
);

export default React.memo(CourseSettings) as any;
